import { render, staticRenderFns } from "./PostPreview.vue?vue&type=template&id=9b902b16&scoped=true&"
import script from "./PostPreview.vue?vue&type=script&lang=js&"
export * from "./PostPreview.vue?vue&type=script&lang=js&"
import style0 from "./PostPreview.vue?vue&type=style&index=0&id=9b902b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b902b16",
  null
  
)

export default component.exports